<template>
<div>
  <v-row wrap class='ma-2 pa-2'>
    <v-col xs="12" class='pt-2 pl-1'>
      <AppTitle icon='remove_red_eye' title='Right Now' />
    </v-col>
    <v-flex xs12 class='pa-2'>
      <v-divider />
    </v-flex>
    <v-flex xs4>
      <AppWeather />
    </v-flex>
    <v-flex xs8>
      <AppUsage />
    </v-flex>
    <v-flex xs12 class='pa-2'>
      <v-divider />
    </v-flex>
    <v-flex xs12 class='pl-1'>
      <AppTitle icon='remove_red_eye' title='Last Week' />
    </v-flex>
    <v-flex xs12 class='mb-3 pa-2'>
      <v-divider />
    </v-flex>
    <v-flex xs6>
      <AppWeeklyEnergyChart :title='items[0].title' :desc='items[0].desc' :color='items[0].color' />
    </v-flex>
    <v-flex xs6>
      <!-- <span class="display-3">Not Available</span> -->
      <AppWeeklyWaterChart :title='items[1].title' :desc='items[1].desc' :color='items[1].color' />
    </v-flex>
    <v-flex xs12 class='pa-2'>
      <v-divider />
    </v-flex>
    <v-flex xs12 class='pl-1'>
      <AppTitle icon='remove_red_eye' title='Today' />
    </v-flex>
    <v-flex xs12 class='mb-2 pa-2'>
      <v-divider />
    </v-flex>
    <v-flex xs12 class='pa-2'>
      <AppHourlyEnergyChart title='Energy Usage' desc='Today' color='green lighten-2'/>
    </v-flex>
    <v-flex xs12 class='pa-2'>
      <v-divider />
    </v-flex>
    <v-flex xs12>
      <AppSimulator />
    </v-flex>
    <v-flex xs12 class='pa-2'>
      <v-divider />
    </v-flex>
  </v-row>
</div>
</template>


<script>
import AppTitle                   from '@/components/shared/Title'
import AppSimulator               from '@/components/Simulator'
import AppWeather                 from '@/components/subs/weather'
import AppUsage                   from '@/components/subs/usage'
import AppWeeklyEnergyChart       from '@/components/subs/weeklyEnergyChart'
import AppWeeklyWaterChart        from '@/components/subs/weeklyWaterChart'
import AppHourlyEnergyChart       from '@/components/subs/hourlyEnergyChart'
import SkysparkService            from '@/skyspark_services/GetSkysparkData'
// import skysparkRequest from '@/skyspark_request.js'
// import urllib        from 'urllib'

export default {
  data: () => ({
      items: [
        { title: 'Energy Usage', desc: 'Last Week', color: 'purple lighten-2' },
        { title: 'Water Usage', desc: 'Last Week', color: 'pink lighten-2' }
      ],
      kendedaData: [],
  }),
  computed: {

  },
  methods: {
    async getKBData (){
      const tempResponse = await SkysparkService.getSkysparkData({
        method: "getLastData",
        endpoint: "@p:gaTech:r:25389911-6d045878",
        n: "1",
      })
      // console.log(response)
      // console.log(tempResponse)
      let tempData = tempResponse.data.split('\n');
      tempData = tempData.slice(-3,-2)
      // console.log(tempData)
      let dateData = new Date(tempData[0].split(',')[0].split(" ")[0]);
      tempData = Math.round(10*parseFloat(tempData[0].split(',')[1]))/10 + tempData[0].split(',')[1].slice(-2);
      this.$store.commit('updateKBDate',dateData);
      this.$store.commit('updateKBTemp',tempData);

      const reqPowerResponse = await SkysparkService.getSkysparkData({
        method: "getLastData",
        endpoint: "@p:gaTech:r:25168db0-23469c3e",
        // date: "today", //"yyyy-mm-dd..yyyy-mm-dd", "yesterday", "lastWeek", "lastMonth"
        // rollup: "avg", //"min", "max", "sum", "avg"
        // interval: "1hr" //"min", "hr", "day", "1wk", "1mo"
        n: "1",
      })
      // console.log(response)
      // console.log(reqPowerResponse.data)
      let reqPowerData = reqPowerResponse.data.split('\n');
      reqPowerData = reqPowerData.slice(-3,-2)[0].split(',')[1];
      reqPowerData = Math.round(10*parseFloat(reqPowerData))/10 + reqPowerData.slice(-2);
      // console.log(reqPowerData)
      this.$store.commit('updateKBReqPower',reqPowerData);

      const solarPowerResponse = await SkysparkService.getSkysparkData({
        method: "getLastData",
        endpoint: "@p:gaTech:r:25168ddb-18f219e7",
        n: "1",
      })
      // console.log(response)
      // console.log(solarPowerResponse.data)
      let solarPowerData = solarPowerResponse.data.split('\n');
      // console.log(solarPowerData)
      solarPowerData = solarPowerData.slice(-3,-2)[0].split(',')[1];
      solarPowerData = Math.round(10*parseFloat(solarPowerData))/10 + solarPowerData.slice(-2);
      // console.log(solarPowerData)
      this.$store.commit('updateKBSolarPower',solarPowerData);

      const netPowerResponse = await SkysparkService.getSkysparkData({
        method: "getLastData",
        endpoint: "@p:gaTech:r:251cf88f-be5b0d6b",
        n: "1",
      })
      // console.log(response)
      // console.log(solarPowerResponse.data)
      let netPowerData = netPowerResponse.data.split('\n');
      // console.log(solarPowerData)
      netPowerData = netPowerData.slice(-3,-2)[0].split(',')[1];
      netPowerData = Math.round(-10*parseFloat(netPowerData))/10 + netPowerData.slice(-2);
      // console.log(solarPowerData)
      this.$store.commit('updateKBNetPower',netPowerData);

      // console.log("Now to get the weekly data")
      const weeklyBuildingLoadResponse = await SkysparkService.getSkysparkData({
        method: "getData",
        endpoint: "@p:gaTech:r:25168db0-23469c3e",
        date: "lastWeek",
        rollup: "avg",
        interval: "1day"
      })
      // console.log(response)
      // console.log(weeklyBuildingLoadResponse.data)
      let weeklyBuildingLoadData = weeklyBuildingLoadResponse.data.split('\n');
      weeklyBuildingLoadData = weeklyBuildingLoadData.slice(2,-2);
      weeklyBuildingLoadData.forEach((item,index) => weeklyBuildingLoadData[index] = 24*parseInt(item.split(',')[1].slice(0,-2)));
      // console.log(weeklyBuildingLoadData)
      // energyUseData.forEach((item,index) => energyUseData[index] = item.split(',')[1]);
      this.$store.commit('updateKBWeeklyBuildingLoad',weeklyBuildingLoadData);

      const weeklyNetPowerResponse = await SkysparkService.getSkysparkData({
        method: "getData",
        endpoint: "@p:gaTech:r:251cf88f-be5b0d6b",
        date: "lastWeek",
        rollup: "avg",
        interval: "1day"
      })
      // console.log(response)
      // console.log(response.data)
      let weeklyNetPowerData = weeklyNetPowerResponse.data.split('\n');
      weeklyNetPowerData = weeklyNetPowerData.slice(2,-2);
      weeklyNetPowerData.forEach((item,index) => weeklyNetPowerData[index] = -24*parseInt(item.split(',')[1].slice(0,-2)));
      // console.log(weeklyNetPowerData)
      // energyUseData.forEach((item,index) => energyUseData[index] = item.split(',')[1]);
      this.$store.commit('updateKBWeeklyNetPower',weeklyNetPowerData);

      // const yesterdayBuildingLoadResponse = await SkysparkService.getSkysparkData({
      //   method: "getData",
      //   endpoint: "@p:gaTech:r:25168db0-23469c3e",
      //   date: "yesterday",
      //   rollup: "avg",
      //   interval: "1hr"
      // })
      // // console.log(response)
      // // console.log(yesterdayBuildingLoadResponse.data)
      // let yesterdayBuildingLoadData = yesterdayBuildingLoadResponse.data.split('\n');
      // yesterdayBuildingLoadData = yesterdayBuildingLoadData.slice(2,-2);
      // yesterdayBuildingLoadData.forEach((item,index) => yesterdayBuildingLoadData[index] = item.split(','));
      // yesterdayBuildingLoadData.forEach((item,index) => {
      //   yesterdayBuildingLoadData[index][0] = new Date(item[0].split(" ")[0]);
      //   yesterdayBuildingLoadData[index][1] = Math.round(10*parseFloat(item[1].slice(0,-2)))/10;
      // })
      // // energyUseData.forEach((item,index) => energyUseData[index] = item.split(',')[1]);
      // this.$store.commit('updateKBYesterdayBuildingLoad',yesterdayBuildingLoadData);

      const todayBuildingLoadResponse = await SkysparkService.getSkysparkData({
        method: "getData",
        endpoint: "@p:gaTech:r:25168db0-23469c3e",
        date: "today",
        rollup: "avg",
        interval: "1hr"
      })
      // console.log(response)
      // console.log(response.data)
      let todayBuildingLoadData = todayBuildingLoadResponse.data.split('\n');
      todayBuildingLoadData = todayBuildingLoadData.slice(2,-2);
      todayBuildingLoadData.forEach((item,index) => todayBuildingLoadData[index] = item.split(','));
      todayBuildingLoadData.forEach((item,index) => {
        todayBuildingLoadData[index][0] = new Date(item[0].split(" ")[0]);
        todayBuildingLoadData[index][1] = Math.round(10*parseFloat(item[1].slice(0,-2)))/10;
      })
      // console.log(weeklyNetPowerData)
      // energyUseData.forEach((item,index) => energyUseData[index] = item.split(',')[1]);
      this.$store.commit('updateKBTodayBuildingLoad',todayBuildingLoadData);

      // const yesterdayNetPowerResponse = await SkysparkService.getSkysparkData({
      //   method: "getData",
      //   endpoint: "@p:gaTech:r:251cf88f-be5b0d6b",
      //   date: "yesterday",
      //   rollup: "avg",
      //   interval: "1hr"
      // })
      // // console.log(response)
      // console.log(yesterdayNetPowerResponse.data)
      // let yesterdayNetPowerData = yesterdayNetPowerResponse.data.split('\n');
      // yesterdayNetPowerData = yesterdayNetPowerData.slice(2,-2);
      // yesterdayNetPowerData.forEach((item,index) => yesterdayNetPowerData[index] = item.split(','));
      // yesterdayNetPowerData.forEach((item,index) => {
      //   yesterdayNetPowerData[index][0] = new Date(item[0].split(" ")[0]);
      //   yesterdayNetPowerData[index][1] = Math.round(-10*parseFloat(item[1].slice(0,-2)))/10;
      // })
      // // console.log(weeklyNetPowerData)
      // // energyUseData.forEach((item,index) => energyUseData[index] = item.split(',')[1]);
      // this.$store.commit('updateKBYesterdayNetPower',yesterdayNetPowerData);

      const todayNetPowerResponse = await SkysparkService.getSkysparkData({
        method: "getData",
        endpoint: "@p:gaTech:r:251cf88f-be5b0d6b",
        date: "today",
        rollup: "avg",
        interval: "1hr"
      })
      // console.log(response)
      // console.log(response.data)
      let todayNetPowerData = todayNetPowerResponse.data.split('\n');
      todayNetPowerData = todayNetPowerData.slice(2,-2);
      todayNetPowerData.forEach((item,index) => todayNetPowerData[index] = item.split(','));
      todayNetPowerData.forEach((item,index) => {
        todayNetPowerData[index][0] = new Date(item[0].split(" ")[0]);
        todayNetPowerData[index][1] = Math.round(-10*parseFloat(item[1].slice(0,-2)))/10;
      })
      // console.log(weeklyNetPowerData)
      // energyUseData.forEach((item,index) => energyUseData[index] = item.split(',')[1]);
      this.$store.commit('updateKBTodayNetPower',todayNetPowerData);
    },
  },
  beforeMount() {
    console.log('Mounting Dashboard')
    this.getKBData();
  },
  components: {
    AppWeather,
    AppSimulator,
    AppTitle,
    AppUsage,
    AppWeeklyEnergyChart,
    AppWeeklyWaterChart,
    AppHourlyEnergyChart,
  }
}
</script>
